'use strict';

import React from 'react';
const forEach = require('lodash/forEach');
const uuid = require('uuid');
const Moment = require('moment');

const GlobalUserActions = require('../../actions/GlobalUserActions');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
const ServerRequest = require('../../actions/request');

import LoadingMainContent from '../loading/LoadingMainContent';
import AdminOverviewRange from './AdminOverviewRange';

const STAT_LIST = [
    { id: 'orgs',                   displayName: 'Organizations'},
    { id: 'users',                  displayName: 'Authors'},
    { id: 'external_users',         displayName: 'External Users'},
    { id: 'projects',               displayName: 'Projects'},
    { id: 'activities',             displayName: 'Activities'},
    { id: 'assignments',            displayName: 'Assignments'},
    { id: 'groups',                 displayName: 'Groups'},
    { id: 'activity_instances',     displayName: 'Activity Instances'},
    { id: 'date',                   displayName: 'Date'}
];

const DATE_FORMAT = 'h:mmA M/D';

const propTypes = {};
const defaultProps = {};

class AdminOverView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userStoreState: AdminGlobalUserStore.getState()
        };

        this.renderAuthorBreakdown = this.renderAuthorBreakdown.bind(this);
        this.renderDetails = this.renderDetails.bind(this);
        this.unsubscribes = [AdminGlobalUserStore.listen(this.onAdminGlobalUserStoreStateChange.bind(this))];
        this.pollTaskManager = new ServerRequest.PollTaskManager();
    }

    componentDidMount() {
        const actionId = uuid.v4();
        GlobalUserActions.getOverviewStats(actionId, this.pollTaskManager);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        this.pollTaskManager.abandonTasks();
    }

    onAdminGlobalUserStoreStateChange(state) {
        this.setState({ userStoreState: state });
    }

    getValueForId(ss,id) { // eslint-disable-line @eslint-react/no-unused-class-component-members
        let v;
        let skipNumberConversion = false;

        if (ss.userStoreState.overviewStats) {
            switch(id) {
                case 'users':
                    v =  ss.userStoreState.overviewStats.numAuthors;
                    break;
                case 'orgs':
                    v =  ss.userStoreState.overviewStats.numOrgs;
                    break;
                case 'external_users':
                    v =  ss.userStoreState.overviewStats.numExternalUsers;
                    break;
                case 'projects':
                    v = ss.userStoreState.overviewStats.numProjects;
                    break;
                case 'activities':
                    v =  ss.userStoreState.overviewStats.numActivities;
                    break;
                case 'assignments':
                    v =  ss.userStoreState.overviewStats.numAssignments;
                    break;
                case 'groups':
                    v =  ss.userStoreState.overviewStats.numGroups;
                    break;
                case 'activity_instances':
                    v = ss.userStoreState.overviewStats.numActivityInstances;
                    break;
                case 'date':
                    v = Moment(ss.userStoreState.overviewStats.date).format(DATE_FORMAT);
                    skipNumberConversion = true;
                    break;
                default:
                    console.log(`AdminOverView getValueForId ${id} not handled.`);
            }

            if (typeof v === 'undefined') {
                return 'loading...';
            }

            if (!skipNumberConversion) {
                v = Number(v);
                v = v.toLocaleString(); // thousands separator
            }

            return v;
        }

    }

    renderAuthorBreakdown() {
        let items = [];
        if (this.state.userStoreState.overviewStats) {
            Object.keys(this.state.userStoreState.overviewStats.countsForType).forEach((key) => {
                const count = (this.state.userStoreState.overviewStats.countsForType[key]);
                const formattedCount = Number(count).toLocaleString();
                items.push(
                    <li key={key}>
                        <label>{key.toLowerCase() + ':'}</label><span className="overview-integer">{formattedCount}</span>
                    </li>
                );
            });
        }
        return (
            <div className="overview-detail-section">
                <ul>
                    {items}
                </ul>
            </div>
        );
    }

    renderDetails(id) {
        switch (id) {
            case 'users':
                return this.renderAuthorBreakdown();
        }

        return null; // some have no details
    }

    render() {
        const self = this;

        return (
            <div>
                <div className="admin-overview-tab">
                    <div className="margin-bottom-lg">
                        <h2 className="view-title">Version</h2>
                        <ul>
                            <li>Server: {GlobalConfig.ServerVersion}</li>
                            <li>Client: {GlobalConfig.ClientVersion}</li>
                        </ul>
                    </div>
                    <div className="margin-bottom-lg">
                    <h2 className="view-title">Overview</h2>
                        <ul>
                            {STAT_LIST.map(entry => { return (
                                <li key={entry.id}>
                                    <label>{entry.displayName + ':'}</label><span className="overview-integer">{self.getValueForId(self.state,entry.id)}</span>
                                    {self.renderDetails(entry.id)}
                                </li>
                            )})}
                        </ul>
                    </div>
                </div>
                <AdminOverviewRange />
            </div>
        );
    }
}

AdminOverView.propTypes = propTypes;
AdminOverView.defaultProps = defaultProps;

export default AdminOverView;